import { z } from 'zod';
/**
 * Analyst-authored correction to a single AI synthesis section
 * (frontend spec §5.9 — human-in-the-loop inline correction).
 *
 * Overrides never silently replace AI output: the UI flags the section
 * as "edited by {authorName}" and keeps the original visible in the
 * version history (via `supersedes` chains).
 */
export const SynthesisOverride = z.object({
    id: z.string(),
    orgId: z.string(),
    entityName: z.string(),
    sectionHeading: z.string(),
    body: z.string(),
    authorUid: z.string(),
    authorName: z.string().optional(),
    reason: z.string().optional(),
    createdAt: z.string(),
    /** Doc id of the prior override this one replaces (if any). */
    supersedes: z.string().optional(),
});
